export default "__VITE_ASSET__a4caa64f__"